import { render, staticRenderFns } from "./Organigrama.vue?vue&type=template&id=5d1bf430&scoped=true&"
import script from "./Organigrama.vue?vue&type=script&lang=js&"
export * from "./Organigrama.vue?vue&type=script&lang=js&"
import style0 from "./Organigrama.vue?vue&type=style&index=0&id=5d1bf430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1bf430",
  null
  
)

export default component.exports